<template>
    <div class="panel panel-default">
        <div class="inspection-tab-white">

            <div ref="slick_nav" class="slick_nav">
                <a href="#" v-for="inspection_diagnostic in inspection_diagnostics">
                    <img :src="`${ inspection_diagnostic.photo }`" alt="">
                </a>
            </div>

            <div ref="slick_for" class="slick_for">
                <a v-for="inspection_diagnostic in inspection_diagnostics" :href="`${ inspection_diagnostic.photo }`" target="_blank">
                    <img :src="`${ inspection_diagnostic.photo }`" alt="">
                </a>
            </div>

        </div>
    </div>
</template>

<script>
    import axios from 'axios'
    import _ from 'lodash'
    import Slick from 'vue-slick'

    export default {
        name: 'InspectionDiagnostic',

        props: ['inspection_id'],
        asyncComputed: {
            inspection_diagnostics() {
                return axios
                    .get('/api/inspections/' + this.inspection_id + '/diagnostic', {
                        params: {}
                    })
                    .then(({data}) => {
                        return data
                    })
            },
        },
        updated () {
            if (this.inspection_diagnostics.length > 1) {
                $(this.$refs.slick_for).slick({
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    dots: false,
                    arrows: true,
                    prevArrow: '<button type="button" class="slick-prev"></button>',
                    nextArrow: '<button type="button" class="slick-next"></button>',
                    fade: true,
                    asNavFor: this.$refs.slick_nav
                });
                $(this.$refs.slick_nav).slick({
                    autoplay: true,
                    //slidesToShow: 5,
                    slidesToScroll: 1,
                    asNavFor: this.$refs.slick_for,
                    dots: false,
                    arrows: false,
                    centerMode: true,
                    focusOnSelect: true,
                    variableWidth: true
                });
            }
        }
    }
</script>



// WEBPACK FOOTER //
// InspectionDiagnostic.vue?647e496e